import { Core } from "@faire/design-tokens";
import home from "@faire/web-api/routes/support";
import { useStrictLocalization } from "@faire/web/common/localization";
import { FaireLogo } from "@faire/web/slate/logos/FaireLogo";
import { getSpacing, Spacer } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web/slate/Typography";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { footerIntro } from "./footerContent";
var useFaireIntroVariant = function useFaireIntroVariant() {
  var _useViewport = useViewport(),
    isTablet = _useViewport.isTablet,
    isDesktopAndAbove = _useViewport.isDesktopAndAbove;
  var introVariant = "pageHeaderSerifRegular";
  if (isTablet) {
    introVariant = "pageHeaderSerifRegular";
  } else if (isDesktopAndAbove) {
    introVariant = "displaySSerifRegular";
  }
  return introVariant;
};
export var FaireIntro = function FaireIntro() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var introVariant = useFaireIntroVariant();
  return /*#__PURE__*/React.createElement(FaireIntroWrapper, null, /*#__PURE__*/React.createElement(Link, {
    to: home()
  }, /*#__PURE__*/React.createElement(FaireLogo, null)), /*#__PURE__*/React.createElement(Spacer, {
    size: 12
  }), /*#__PURE__*/React.createElement(IntroParagraph, {
    variant: introVariant
  }, footerIntro(strictLocalize)));
};
var FaireIntroWrapper = styled.div.withConfig({
  displayName: "FaireIntro__FaireIntroWrapper"
})(["margin-right:auto;", "{margin-top:", ";padding-bottom:", ";margin-bottom:", ";border-bottom:1px solid ", ";}", "{padding-right:", ";}"], responsiveMediaQueries.mobile, getSpacing("2x"), getSpacing("2x"), getSpacing("2x"), Core.border.muted, responsiveMediaQueries.tabletAndAbove, getSpacing("2x"));
var IntroParagraph = styled(Typography).withConfig({
  displayName: "FaireIntro__IntroParagraph"
})(["&&&{", "{font-size:20px;margin-top:", ";}", "{margin-top:", ";max-width:30ch;}}"], responsiveMediaQueries.mobile, getSpacing("1x"), responsiveMediaQueries.tabletAndAbove, getSpacing("2x"));